// start:ng42.barrel
import './clubs.service';
// end:ng42.barrel

